import AccessTimeIcon from '@mui/icons-material/AccessTime';

const icons = {
    AccessTimeIcon
};

const eTAReminder = {
    id: 'eTAReminder',
    type: 'group',
    children: [
        {
            id: 'eTAReminder',
            title: 'ETA Reminder',
            type: 'item',
            url: '/eTAReminder',
            icon: icons.AccessTimeIcon,
        }
    ]
};

export default eTAReminder;
